import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {
	return {
		dashboardErrorPage: {
			width           : "100%",
			height          : theme.other.isMobile ? "100%" : "auto",
			backgroundColor : theme.other.darkMode ? theme.other.paletteNew.secondaryBlack : theme.other.paletteNew.secondaryWhite
		}
	};
} );
